// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { PaymentStatusEnum } from "../common/enums";

export default function (
    state: OrderResponse = initialState.orderResponse,
  action: any
) {
    let data = initialState.orderResponse;

    switch (action.type) {
      case ActionTypes.ORDER_CHECKOUT + ActionTypes.FULFILLED:
           data = action.payload.data;
          return {
              requiresActionExternalRedirect: data.requiresActionExternalRedirect,
              paymentProviderRedirectURL: data.paymentProviderRedirectURL,
              newOrderId: data.orderId
          }
      case ActionTypes.CLEAR_ORDER: //+ ActionTypes.FULFILLED: NO NEED FOR fulfilled as this is not ajax request
            return initialState.orderResponse;
        case ActionTypes.CANCEL_EXTERNAL_REDIRECT:  
            return { requiresActionExternalRedirect: false, paymentProviderRedirectURL: '', newOrderId: 0, failedExternalRedirectSVerification: true };
      case ActionTypes.AUTHORIZE_PAYMENT + ActionTypes.FULFILLED: 
            data = action.payload.data;
            if (data.status === PaymentStatusEnum.Successful || data.status === PaymentStatusEnum.RequiresCapture) {
                return { ...state, requiresActionExternalRedirect: false, paymentProviderRedirectURL: '', failedExternalRedirectSVerification: false };
          } else {
                return { requiresActionExternalRedirect: false, paymentProviderRedirectURL: '', newOrderId: 0, failedExternalRedirectSVerification: true };
          }
      case ActionTypes.AUTHORIZE_PAYMENT + ActionTypes.REJECTED:
            return { requiresActionExternalRedirect: false, paymentProviderRedirectURL: '', newOrderId: 0, failedExternalRedirectSVerification: true };
          
    default:
      return state;
  }
}
